<script >
import { defineAsyncComponent } from 'vue-demi';
import CONSTANT from '../common/constants';
import useCssVar from '../composables/useCssVar';
import useSwiper from '../composables/useSwiper';
const FlowContainer = defineAsyncComponent(() => Promise.resolve(require('@futuweb/fego-render')?.plugins.ComplexComp.Container.Flow));
const __sfc_main = {};
__sfc_main.props = {
  tpl: Object,
  layout: String,
  itemBetween: {
    type: Number,
    default: 32
  },
  spaceBetween: {
    type: Number,
    default: 50
  },
  swiperSlideType: String,
  swiperWidth: {
    type: Number,
    default: 320
  },
  swiperHeight: {
    type: Number,
    default: 320
  },
  // loop: {
  //     type: Boolean,
  //     default: true
  // },
  autoplay: {
    type: Boolean,
    default: true
  },
  autoplayDelay: {
    type: Number,
    default: 3
  },
  indexBgColor: String,
  indexActiveBgColor: String,
  indexColor: String,
  indexActiveColor: String,
  lineColor: String,
  list: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useLang /* useEnv */
  } = require('@fegobull/webapi').use;
  const {
    SWIPER_SLIDE_TYPE
  } = CONSTANT;
  const props = __props;
  const {
    cssVar
  } = useCssVar(props);
  const {
    activeIndex,
    swiperRef,
    slideTo
  } = useSwiper(props);
  const {
    langText
  } = useLang();
  return {
    SWIPER_SLIDE_TYPE,
    cssVar,
    activeIndex,
    swiperRef,
    slideTo,
    langText
  };
};
__sfc_main.components = Object.assign({
  FlowContainer
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div :class="['step-swiper-container', layout, langText]" :style="cssVar">
        <div class="v-swiper" ref="swiperRef">
            <div class="swiper-wrapper">
                <div v-for="(item, i) in list" :key="i" class="swiper-slide">
                    <flow-container
                        v-if="swiperSlideType === SWIPER_SLIDE_TYPE.VIDEO"
                        :children="tpl.children[i] ? [tpl.children[i]] : []"
                    />
                    <img v-else class="swiper-item" :src="item.img" :alt="item.alt" />
                </div>
            </div>
        </div>
        <ul class="step-list">
            <li
                v-for="(item, i) in list"
                :key="i"
                :class="['step-item', { active: i === activeIndex }]"
                @click="slideTo(i)"
            >
                <div class="step-item__index">{{ i + 1 }}</div>
                <div class="step-item__content">
                    <p class="step-item__content-title" v-html="item.title"></p>
                    <p class="step-item__content-desc" v-html="item.desc"></p>
                </div>
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
<style lang="less">
// 为了覆盖富文本中另外设置颜色的span，选中态的颜色，需全局注入
// 因为css变量是作用范围仅当前组件，有隔离，不会相互污染
.step-list .step-item.active .step-item__content-title {
    span {
        color: var(--index-active-bg-color) !important;
    }
}
</style>
